module.exports = __webpack_public_path__ + "media/images/stock_groups/e878-2fc15fcaf3d3990a435fb7c953441aaf.svg";